$(document).ready(function () {
    //visualização de estoque
    var currentValue = $('#id_mapr').val(); 

    function checkValueChange() {
        var newValue = $('#id_mapr').val();
        if (newValue !== currentValue && newValue !== '') {
            
            currentValue = newValue; 

            $.ajax({
                url: '/consultapaciente/visualizarestoque',
                type: 'GET',
                data: { id_mapr: newValue },
                dataType: 'json',
                success: function(estoques) {
                    if (estoques.length > 0) {
                        var html = '';
                        estoques.forEach(function(estoque) {
                            var nomeMaterial;

                            if (estoque.no_material_completo && !estoque.nao_exibe_estoque) {
                                nomeMaterial = estoque.no_material_completo;
                            } else if (!estoque.nao_exibe_estoque){
                                nomeMaterial = estoque.no_material + ' ' + estoque.no_material_apresentacao;
                            } else {
                                nomeMaterial = estoque.no_material
                            }

                            var quantidade = estoque.hasOwnProperty('est_final') ? parseFloat(estoque.est_final).toFixed(0) : 0,
                            unidade = estoque.nao_exibe_estoque? estoque.no_material_apresentacao : estoque.UnidadeMovimento,
                            iconCheck = '<svg width="20px" height="20px" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" fill="none"><path fill="green" fill-rule="evenodd" d="M3 10a7 7 0 019.307-6.611 1 1 0 00.658-1.889 9 9 0 105.98 7.501 1 1 0 00-1.988.22A7 7 0 113 10zm14.75-5.338a1 1 0 00-1.5-1.324l-6.435 7.28-3.183-2.593a1 1 0 00-1.264 1.55l3.929 3.2a1 1 0 001.38-.113l7.072-8z"/></svg>',
                            iconCancel = '<svg fill="red" width="20px" height="20px" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg"><title>cancel</title><path d="M10.771 8.518c-1.144 0.215-2.83 2.171-2.086 2.915l4.573 4.571-4.573 4.571c-0.915 0.915 1.829 3.656 2.744 2.742l4.573-4.571 4.573 4.571c0.915 0.915 3.658-1.829 2.744-2.742l-4.573-4.571 4.573-4.571c0.915-0.915-1.829-3.656-2.744-2.742l-4.573 4.571-4.573-4.571c-0.173-0.171-0.394-0.223-0.657-0.173v0zM16 1c-8.285 0-15 6.716-15 15s6.715 15 15 15 15-6.716 15-15-6.715-15-15-15zM16 4.75c6.213 0 11.25 5.037 11.25 11.25s-5.037 11.25-11.25 11.25-11.25-5.037-11.25-11.25c0.001-6.213 5.037-11.25 11.25-11.25z"></path></svg>',
                            legenda = '';

                            if (estoque.nao_exibe_estoque) {
                                quantidade = estoque.possui_estoque ? iconCheck : iconCancel;
                                legenda = '<div class="d-flex">' +
                                              '<p>' + iconCheck + ' Tem disponibilidade em estoque</p>' +
                                              '<p>' + iconCancel + ' Não Tem disponibilidade em estoque</p>' +
                                          '</div>';
                            }

                            html += '<tr>' +
                                        '<td>' + nomeMaterial + '</td>' +
                                        '<td>' + unidade + '</td>' +
                                        '<td>' + quantidade + '</td>' +
                                        '<td>' + estoque.ups_nome + ' (' + estoque.ups_id + ')</td>' +
                                    '</tr>' +
                                    legenda;
                        });
                        $('#estoqueContainer').find('tbody').html(html);
                        $('#estoqueContainer').show(); 
                    } else {
                        $('#estoqueContainer').find('tbody').html('<tr><td colspan="4">Material não tem estoque em nenhuma unidade listada abaixo.</td></tr>');
                        $('#estoqueContainer').show();
                    }
                },
                error: function(xhr, status, error) {
                    console.error("Erro ao buscar estoque: " + error);
                    $('#estoqueContainer').hide(); 
                }
            });
        }
    }

    $('#id_mapr').on('input change', checkValueChange);

    setInterval(checkValueChange, 500);
    //fim visualização de estoque

    $(document).on('change', "#login_dt_nascimento, #login_vacina_dt_nascimento", function (e) {
        let data = e.currentTarget.value;
        if (data.length < 10) {
            alert(
                "Você precisa digitar a data de nascimento completa. Exemplo: 00/00/0000"
            );
        }

        let dia = data.split("/")[0];
        let mes = parseInt(data.split("/")[1]) - 1;
        let ano = data.split("/")[2];

        let dataInserida = new Date(ano, mes, dia);
        let dataMinima = new Date("1900-01-01");
        let dataMaxima = new Date("2199-12-31");
        if (dataInserida < dataMinima) {
            alert(
                "A data de nascimento informada está incorreta, idade minima [01/01/1900]. Favor digitar novamente a data de nascimento."
            );
            e.currentTarget.value = "";
        }

        if (dataInserida > dataMaxima) {
            alert(
                "A data de nascimento informada está incorreta. idade máxima [31/12/2199]. Favor digitar novamente a data de nascimento."
            );
            e.currentTarget.value = "";
        }
    });

    adicionaRemoveRequerido("#login_paciente_cpf-label label", true);
    adicionaRemoveRequerido("#login_paciente_cns-label label", true);

    adicionaRemoveRequerido("#login_paciente_vacina_cpf-label label", true);
    adicionaRemoveRequerido("#login_paciente_vacina_cns-label label", true);

    $(document).on('change', "#login_paciente_cns, #login_paciente_vacina_cns", function (e) {
        validaCns(e.currentTarget);
    });
    $("#detail").tabs({
        show: function () {
            $("input[type=text]:not([readonly]):visible:enabled:eq(0)")
                .focus()
                .select();
            return true;
        },
    });

    if ($("#nivel_seguranca").val() == 1) {
        $(document).on('blur', "#login_paciente_cpf, #login_paciente_vacina_cpf", function (e) {
            const idCPF = $(e.currentTarget).attr('id')
            const idCnsArray = idCPF.split('_')
            idCnsArray.pop()
            const idCns = idCnsArray.join('_') + '_cns'
            if ($(e.currentTarget).val().startsWith("_")) {
                adicionaRemoveRequerido(`#${idCPF}-label label`, true);
                adicionaRemoveRequerido(`#${idCns}-label label`, true);
                return;
            }
            if (
                $(`#${idCPF}`).val() &&
                $(`#${idCPF}`)
                    .val()
                    .match(/^[0-9]{3}\.[0-9]{3}\.[0-9]{3}\-[0-9]{2}$/) === null
            ) {
                alert("O CPF informado é inválido.");
                adicionaRemoveRequerido(`#${idCPF}-label label`, true);
                adicionaRemoveRequerido(`#${idCns}-label label`, true);
                $(`#${idCPF}`).val("");
            } else {
                adicionaRemoveRequerido(`#${idCns}-label label`, false);
            }
        });

        $(document).on('blur', '#login_paciente_cns, #login_paciente_vacina_cns', function (e) {
            const idCNS = $(e.currentTarget).attr('id')
            const idCPFArray = idCNS.split('_')
            idCPFArray.pop()
            const idCPF = idCPFArray.join('_') + '_cpf'
            if ($(`#${idCNS}`).val()) {
                adicionaRemoveRequerido(`#${idCPF}-label label`, false);
            } else {
                adicionaRemoveRequerido(`#${idCPF}-label label`, true);
            }
        });
    } else {
        if (
            $("#login_paciente_cpf").val() &&
            $("#login_paciente_cpf")
                .val()
                .match(/^[0-9]{3}\.[0-9]{3}\.[0-9]{3}\-[0-9]{2}$/) === null
        ) {
            alert("O CPF informado é inválido.");
            $("#login_paciente_cpf").val("");
        }
    }

    $("input[name=tipo]").change(function () {
        adicionaRemoveRequerido("#login_paciente-label label", true);
        adicionaRemoveRequerido("#login_dt_nascimento-label label", true);
        adicionaRemoveRequerido("#login_vacina_dt_nascimento-label label", true);

        adicionaRemoveRequerido("#numero_protocolo-label label", true);
        adicionaRemoveRequerido("#data_nascimento-label label", true);

        if ($("input[name=tipo]:checked").val() === "0") {
            $("#fieldset-consulta").show();
            $("#fieldset-consulta_laboratorio").hide();
            $("#login_paciente").focus().select();
        } else {
            $("#fieldset-consulta").hide();
            $("#fieldset-consulta_laboratorio").show();
            $("#numero_protocolo").focus().select();
        }
    });

    $("#submit_vacinas,#submit_laboratorio,#submit").on("click", function (e) {
        carrega("conteudo_lista");
        e.preventDefault();
    });

    /**
     * impressão de Laudo pelo filtro
     */
    $(document).on("click", "#imprimir_laboratorio", function (e) {
        chamaImpressaoFiltro("impressaoLaudo", "consultapaciente/imprimelaudo");
        e.preventDefault();
    });

    $("input[name=tipo]").trigger("change");
    /**
     * impressão comprovante vacina
     */
    $(document).on('click', '#imprimir_vacinas', _ => {
        imprimecomprovantevacina();
    });
    
    $(document).on('click', '#imprimir_vacinas_en', _ => {
        imprimecomprovantevacina('en');
    });
    
    $(document).on('click', '#imprimir_vacinas_es', _ => {
        imprimecomprovantevacina('es');
    });
    
    function imprimecomprovantevacina(idioma = 'pt-BR') {
        const aplicacoesIds = []
        $('input[name^=id_aplicacao_]').each((index, item) => {
            aplicacoesIds.push(item.value)
        })

        if (aplicacoesIds.length === 0) {
            alert('Não há registros para emitir o comprovante!');
            return;
        }

        const data = {
            id_usuario_gms: $('#id_usuario_gms').val(),
            ids_imuaplicacoes: aplicacoesIds,
            hash: $('#hash').val(),
            idioma
        }
        $.blockUI({message: "<h1>Gerando comprovante...</h1>"});
        const headers = new Headers();
        headers.append("X-Requested-With", "XMLHttpRequest");
        headers.append('Content-Type', 'application/json');
        fetch(
            '/consultapaciente/imprimecomprovantevacina', {
                method: 'POST',
                headers: headers,
                body: JSON.stringify(data),
                credentials: 'same-origin'
            }).then(res => {
            const contentType = res.headers.get("content-type");
            if (contentType && contentType.indexOf("application/json") !== -1) {
                return res.json();
            }

            return res.blob()
        }).then(dataResponse => {
            if (typeof dataResponse === 'object' && dataResponse.success === false) {
                alert(dataResponse.message);
                return;
            }
            const downloadLink = document.createElement("a");
            downloadLink.download = 'comprovante_vacinacao.pdf';
            downloadLink.innerHTML = "Download";
            downloadLink.href = window.URL.createObjectURL(dataResponse);
            downloadLink.click();
            downloadLink.remove();

        }).catch(err => {
            return err
        }).finally(() => $.unblockUI())
    }
});
/**
 * Carrega a grid por ajax após clicar em Consultar
 * @param {type} div
 * @returns {undefined}
 */
carrega = async function (div) {
    var abaAtiva = $("ul[role=tablist] li[aria-selected=true]").attr(
        "aria-controls"
    );
    var form = $(`#${abaAtiva} form`).attr('id')
    var action = abaAtiva;

    if (action === "informacoes") {
        const data = await requestValidacao(action, div, form);
        if (data.success === false) {
            alert(data.message);
            return;
        }

        if (data.valid_no_mae) {
            if (
                confirm(`Confirma que o nome da sua mãe é: ${data.no_mae}?`) === false
            )
                return;
        }
    }

    if (action === "laboratorio") {
        const data = await requestValidacao(action, div, form);
        if (data.success === false) {
            alert(data.message);
            return;
        }
    }
    if (action === "vacinas") {
        const data = await requestValidacao(action, div, form);
        if (data.success === false) {
            alert(data.message);
            return;
        }

        if (data.valid_no_mae) {
            if (
                confirm(`Confirma que o nome da sua mãe é: ${data.no_mae}?`) === false
            )
                return;
        }
    }

    $.ajax({
        url: "/padrao/consultapaciente/" + action,
        type: "POST",
        data: $("#" + form).serialize(),
        contentType: "application/x-www-form-urlencoded",
        beforeSend: function () {
            var htmlPreloader = "<br />";
            htmlPreloader += '<div id="loader" style="width:100%;height:50px;';
            htmlPreloader += "border:1px solid #CCCCCC;background-color:#EBEBEB;";
            htmlPreloader += 'text-align:center">';
            htmlPreloader +=
                '<img alt="" src="/img/ajax-loader.gif">&nbsp;Carregando....</div>';
            $("#" + div).html(htmlPreloader);
        },
        complete: function () {
            if ($("#loader").length > 0) $("#loader").remove();
        },
        success: function (data) {
            if (typeof data === 'object' && data.success === false) {
                alert(data.message);
                return;
            }
            $("#" + div).html(data);
            $("#detail2").tabs();

            if ($("#fieldset-usuario1responsavel")) {
                $("#fieldset-usuario1responsavel").remove();
            }
            if ($("#fieldset-display_reenviar_esus")) {
                $("#fieldset-display_reenviar_esus").remove();
            }
            if ($("#nr_pis_pasep")) {
                $("#nr_pis_pasep").parent().parent().remove();
            }
            if ($("#deletedat")) {
                $("#deletedat").parent().parent().remove();
            }
            if ($("#id_sexo")) {
                $("#id_sexo").parent().parent().remove();
            }
            if ($("#fieldset-display_esus")) {
                $("#fieldset-display_esus").remove();
            }
            if ($("#text_id_etnia")) {
                $("#text_id_etnia").removeClass("ac_input");
            }
            if ($("#text_id_mae")) {
                $("#text_id_mae").removeClass("ac_input");
            }
            if ($("#text_id_pai")) {
                $("#text_id_pai").removeClass("ac_input");
            }
            if ($("#text_id_msnacionalidade")) {
                $("#text_id_msnacionalidade").removeClass("ac_input");
            }
            if ($("#text_id_munlocnaturaliade")) {
                $("#text_id_munlocnaturaliade").removeClass("ac_input");
            }
            if ($("#text_end_id_munloc")) {
                $("#text_end_id_munloc").removeClass("ac_input");
            }
            if ($("#text_id_ups_logada")) {
                $("#text_id_ups_logada").removeClass("ac_input");
            }
            if ($("#text_id_profissional_logado")) {
                $("#text_id_profissional_logado").removeClass("ac_input");
            }
            if ($("#text_id_cbo_profissional_logado")) {
                $("#text_id_cbo_profissional_logado").removeClass("ac_input");
            }
            if ($("#text_id_ups_equipe_profissional_logado")) {
                $("#text_id_ups_equipe_profissional_logado").removeClass("ac_input");
            }

            if ($("#fieldset-usuario_contatos").length) {
                let avisoContato = `<div class="msg-info">
                <ul>
                  <li>Por favor, verifique se seus telefones de contato estão atualizados, pois é através deles que entraremos em contato com você para chamá-lo! Caso tenha mudado dirija-se a Unidade de Saúde mais próxima e solicite que seja atualizado.</li>
                </ul>
              </div>`;

                $("#fieldset-usuario_contatos").after(avisoContato);
            }

            if ($("#tabela_lista_filtro").length) {
                let listaEspera = `<div class="msg-info">
                <ul>
                  <li>Clique na aba "INFORMAÇÕES DO CADASTRO DO PACIENTE" para verificar se seus telefones de contato estão atualizados, pois é através desses números que iremos contatá-lo para avisar sobre seu agendamento.</li>
                </ul>
              </div>`;

                $("#tabela_lista_filtro").after(listaEspera);
            }
        },
        error: function (xhr, desc, err) {
            return false;
        },
    });
};

function validaCns(cns) {
    let cnsSemEspaco = cns.value.replace(/\s/g, '');
    let soma = 0;
    if (cnsSemEspaco.length !== 15) {
        alert("O CNS deve conter 15 dígitos, por favor verifique novamente");
        cns.value = "";
        return;
    }

    let list = cnsSemEspaco.split("");
    for (let i = 0; i < 15; i++) {
        soma += parseInt(list[i]) * (15 - i);
    }
    if (soma % 11 !== 0) {
        alert("CNS Inválido");
        cns.value = "";
    }
}


async function requestValidacao(action, div, form) {
    $("#" + div).html("");
    $.blockUI({message: "<h1>Validando informações.</h1>"});

    let headers = new Headers();
    headers.append("X-Requested-With", "XMLHttpRequest");
    headers.append("Content-Type", "application/json");
    headers.append("Accept", "application/json");

    let resultRequest = await fetch(
        `/padrao/consultapaciente/validabusca${action}/`,
        {
            method: "POST",
            body: JSON.stringify($("#" + form).serializeObject()),
            headers: headers,
            credentials: "same-origin",
        }
    );

    $.unblockUI();

    return await resultRequest.json();
}
